module.exports = __webpack_public_path__ + "img/ES.4bd7d035.svg";